'use strict';

var $ = require('jquery');
require('gwwp');
require('./fitYoutubeVideo.js');
require('./navigation.js');
require('./ajaxcalls.js');
// import AOS from 'aos';

require('./fslightbox.js');
require('./calculator.js');
require('./personnel.js');
require('./attributes.js');


import Swiper, { Autoplay, Navigation, Scrollbar } from 'swiper';
Swiper.use([Navigation, Scrollbar, Autoplay]);


$(function () {

    /**
     * Initialise Animate On Sroll
     */
    // AOS.init();


    /**
     * Grand hero slider, there is a maximum of one on each page so we can use a ID
     */
    const grandHeroSliderSpeed = $('#grand_hero').attr('data-slider-speed');
    const grandHero = new Swiper('.grand-hero-swiper-container', {
        // loop: true,
        direction: 'horizontal',
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        autoplay: {
            disableOnInteraction: false // Prevents pausing when moving
        }
    });

    /**
     * Grand hero autoplay is disabled by default, if user has specified a speed for it
     * then autoplay will be started.
     * 
     * This way we can either have or not have autoplay.
     */
    if (grandHeroSliderSpeed && grandHeroSliderSpeed !== 0 && grandHeroSliderSpeed !== '') {
        grandHero.autoplay.start();
    }

    /**
     * Content block articles list (contentblock_articles_list) is a carousel/slider on mobile
     */
    const articlesListContainer = document.getElementsByClassName('articles-list-swiper-container');
    let articlesList;
    if (articlesListContainer.length > 0) {
        articlesList = new Swiper('.articles-list-swiper-container', {
            centeredSlides: true,
            spaceBetween: 10,
            loop: false,
            slidesPerView: 1.2,
        });
    }

    /**
     * Destroy slider if not on devices smaller than 768px screen width.
     */
    const breakpoint = window.matchMedia('(min-width:768px)');
    const breakpointChecker = function () {
        if (breakpoint.matches === true && articlesList !== undefined && (articlesListContainer.length > 0)) {
            articlesList.destroy(true, true);
            return;
        }
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();



    /**
     * Side menu functionality
     */

    let sideMenuParentItems = document.getElementsByClassName("sidemenu_has_children");
    let i;

    for (i = 0; i < sideMenuParentItems.length; i++) {
        sideMenuParentItems[i].addEventListener("click", function (e) {
            e.preventDefault();
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            panel.classList.toggle("submenu-active")
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

    /**
     * Equipment archive accordion
     */
    let acc = document.getElementsByClassName("accordion");
    let j;

    for (j = 0; j < acc.length; j++) {
        acc[j].addEventListener("click", function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

});

